export class CrudWithPreviewDto {
    executed = false;
    previewItems: string[];
}
